module.exports = __webpack_public_path__ + "static/main-portrait-f46ca38194e4be82eb5a3d475c96848d.webp";